import React from "react";
import { observer } from "mobx-react-lite";

import { ButtonsSection } from "../../../components/data-components/sections/DataSections";
import { translationService } from "../../../services/translation/TranslationService";
import RequestOrganizationButton from "./buttons/RequestOrganizationButton";

export default observer(function RequestOrganization() {
  return (
    <div className="option-container">
      <div className="content-text">
        <div className="title">
          {translationService.translate("LandingPage.create-organization")}
        </div>
        <div className="description">
          {translationService.translate("LandingPage.create-organization-description")}
        </div>
        <ButtonsSection>
          <RequestOrganizationButton />
        </ButtonsSection>
      </div>
    </div>
  );
});
